import { useState } from "react";

//  export function TruncateText({ text, maxLength = 25 }) {
//   const [expanded, setExpanded] = useState(false);

//   if (!text) return null;

//   const isLong = text.length > maxLength;
//   const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + "...";

//   return (
//     <span
//       style={{ cursor: isLong ? "pointer" : "default", color:'#404040', }}
//       // title={text}
//       onClick={() => {
//         if (isLong) setExpanded((prev) => !prev);
//       }}
//     >
//       {displayText}
//     </span>
//   );
// }
export function TruncateText({ text, maxLength = 25 }) {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + "...";

  return (
    <span
      style={{ cursor: isLong ? "pointer" : "default", color:'#404040', }}
      title={text}
      // onClick={() => {
      //   if (isLong) setExpanded((prev) => !prev);
      // }}
    >
      {displayText}
    </span>
  );
}

